/** @module root/components/accreditation/sections */

import * as STATES                          from './requirements-assessment.states';
import { IDS }                              from './requirements-assessment-action-id.constants';
import { evidenceGroupsGrid }               from './evidence-groups/evidence-groups-grid.component';
import { evidenceGroupDetails }             from "./evidence-group-details/evidence-group-details.component";
import { evidenceGroups }                   from "./evidence-groups/evidence-groups.component";
import { evidenceGroupDocumentsGrid }       from "./evidence-group-details/evidence-group-documents-grid.component";
import { evidenceGroupHistory }             from "./evidence-group-history/evidence-group-history.component";
import { evidenceGroupHistoryGrid }         from "./evidence-group-history/evidence-group-history-grid.component";
import { evidenceGroupDocRevisionRequest }  from "./evidence-group-doc-revision-request/evidence-group-doc-revision-request.component";
import { evidenceGroupImprovement }         from "./evidence-group-improvement/evidence-group-improvement.component";
import { evidenceGroupImprovementStepsGrid } from "./evidence-group-improvement/evidence-group-improvement-steps-grid.component";

export const REQUIREMENTS_ASSESSMENT_MODULE = angular.module(
    'migration.accreditation.requirements-assessment',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
        Object.values({
            ...STATES,
        }).map(state => stateRegistry.register(state));
    }]
).component({
    evidenceGroups,
    evidenceGroupsGrid,
    evidenceGroupDetails,
    evidenceGroupDocumentsGrid,
    evidenceGroupDocRevisionRequest,
    evidenceGroupImprovement,
    evidenceGroupImprovementStepsGrid,
    evidenceGroupHistory,
    evidenceGroupHistoryGrid,
}).run(['$templateCache', ({ put }) => {
    put(IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,    '<evidence-groups></evidence-groups>');
    put(IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details, '<evidence-group-details></evidence-group-details>');
    put(IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request, '<evidence-group-doc-revision-request></evidence-group-doc-revision-request>');
    put(IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_improvement, '<evidence-group-improvement></evidence-group-improvement>');
    put(IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_history, '<evidence-group-history></evidence-group-history>');
}]);
